import React from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

export default function ReorderContainer({
  items,
  onReorder,
  droppableId,
  direction = "horizontal",
  disabled = false,
  className = "",
  renderItem,
}) {
  if (!items || items.length === 0) {
    return <div className={className} />;
  }

  if (disabled) {
    return (
      <div className={className}>
        {items.map((item, index) => (
          <React.Fragment key={item.id ?? index}>{renderItem(item, index, null)}</React.Fragment>
        ))}
      </div>
    );
  }

  return (
    <DragDropContext
      onDragEnd={(result) => {
        if (!result.destination || result.destination.index === result.source.index) return;
        const reordered = [...items];
        const [moved] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, moved);
        onReorder(reordered);
      }}
    >
      <Droppable droppableId={droppableId} direction={direction}>
        {(provided) => (
          <div ref={provided.innerRef} {...provided.droppableProps} className={className}>
            {items.map((item, index) => (
              <Draggable key={item.id} draggableId={item.id} index={index}>
                {(dragProvided, dragSnapshot) => renderItem(item, index, dragProvided, dragSnapshot)}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}